if (!customElements.get('collection-showcase')) {
  customElements.define(
    'collection-showcase',
    class CollectionShowcase extends HTMLElement {
      constructor() {
        super();
        this.grid = this.querySelector('.collection-showcase__grid');
        if (!this.grid) return;

        this.isDown = false;
        this.startX = 0;
        this.scrollLeft = 0;
        this.dragged = false;

        this.grid.addEventListener('mousedown', this.onMouseDown.bind(this));
        this.grid.addEventListener('mouseleave', this.onMouseUp.bind(this));
        this.grid.addEventListener('mouseup', this.onMouseUp.bind(this));
        this.grid.addEventListener('mousemove', this.onMouseMove.bind(this));
        // Suppress the click-through on a link right after a real drag.
        this.grid.addEventListener(
          'click',
          (event) => {
            if (this.dragged) {
              event.preventDefault();
              event.stopPropagation();
            }
          },
          true
        );
      }

      onMouseDown(event) {
        // Without this, a real (trusted) mousedown on a link/image can kick
        // off the browser's own native drag-and-drop gesture, which then
        // hijacks the mouse and stops delivering plain mousemove events to
        // us entirely — our custom scroll-drag logic never sees them.
        // -webkit-user-drag:none on the image covers Safari/Chrome; this
        // preventDefault is the cross-browser fix (Firefox has no
        // equivalent CSS property).
        event.preventDefault();
        this.isDown = true;
        this.dragged = false;
        this.startX = event.pageX - this.grid.offsetLeft;
        this.scrollLeft = this.grid.scrollLeft;
      }

      onMouseUp() {
        this.isDown = false;
      }

      onMouseMove(event) {
        if (!this.isDown) return;
        event.preventDefault();
        const x = event.pageX - this.grid.offsetLeft;
        const walk = x - this.startX;
        if (Math.abs(walk) > 5) this.dragged = true;
        this.grid.scrollLeft = this.scrollLeft - walk;
      }
    }
  );
}
